import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'ngPercentLimit',
    standalone: false
})
export class NgPercentLimitPipe implements PipeTransform {

	transform(value: number): string {
		if (value < -1) return '<100%';
		if (value > 1)  return '>100%';
		return `${Math.round(value * 100)}%`;
	}
}
